"use client";

import { HugeiconsIcon } from "@hugeicons/react";
import { UserMultiple02Icon } from "@hugeicons/core-free-icons";
import { ResponsivePopover } from "../ui/responsive-popover";
import { Typography } from "../ui/typography";
import { Counter } from "../shared/Counter";

interface PeopleCountInputProps {
  value?: number;
  onChange: (value: number) => void;
  error?: string;
  className?: string;
  disabled?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

export function PeopleCountInput({
  value,
  onChange,
  className = "flex-1 hidden md:flex items-center gap-1.5 cursor-pointer border-none",
  disabled = false,
  open,
  onOpenChange,
}: PeopleCountInputProps) {
  const handleChange = (newValue: number) => {
    if (disabled) return;
    onChange(newValue);
  };

  return (
    <ResponsivePopover
      trigger={
        <div className={className}>
          <HugeiconsIcon
            icon={UserMultiple02Icon}
            size={20}
            strokeWidth={1.5}
            className={`size-5 ${value ? "text-foreground" : "text-black-300"}`}
          />
          <Typography
            variant="bodySRegular"
            color={value ? "default" : "muted"}
            className={`${value ? "font-medium!" : ""}`}
          >
            {value ? `${value} نفر` : "تعداد نفرات"}
          </Typography>
        </div>
      }
      className="md:rounded-[20px] overflow-hidden"
      disabled={disabled}
      open={open}
      onOpenChange={onOpenChange}
    >
      <Counter
        label="تعداد نفرات"
        onChange={handleChange}
        value={value || 0}
        disabled={disabled}
      />
    </ResponsivePopover>
  );
}
